import { insertOrUpdateBlock } from "@blocknote/core";
import type { DefaultReactSuggestionItem } from "@blocknote/react";
import type { BnEditor } from "blocks-schema";
import { Icon, iconStyles } from "ui";

export function insertDividerBlockItems(editor: BnEditor): DefaultReactSuggestionItem[] {
  return [
    {
      title: "Divider",
      subtext: "Visual divider",
      group: "Content",
      icon: <Icon className={iconStyles.neutral600} iconType="DividerBlock" />,
      onItemClick: () => {
        insertOrUpdateBlock(editor, {
          type: "dividerBlock",
          props: {},
        });
      },
    },
  ];
}
